// What a day in the attendance report really is. A day with no attendance row used to be shown as "Absent" even when
// the person was on approved leave or the office was closed; the server now sends `calendar` (holidays and leaves per
// date) and this decides what to show. Order for a day without a check-in: holiday, then weekend, then leave, then Absent.
// A system "Absent" row that has no check-in counts as "no record" too, so an approved leave or a holiday still wins.
//
// Half-day leave: the other half is judged on the check-in. Checked in -> a normal present row with a "1st half leave" tag;
// not checked in -> the leave tag plus "Absent" for the other half.
export function dayOutcome({ rec, calendar, isWeekend }) {
  const c = calendar || {};
  const isLeave = c.kind === 'leave' || c.kind === 'leave_pending';
  const halfLeave = isLeave && c.half ? { label: c.label, part: c.part || null, pending: c.kind === 'leave_pending' } : null;
  if (rec && rec.status !== 'Absent') return { kind: 'present', halfLeave };
  if (c.kind === 'holiday') return { kind: 'holiday', label: c.label };
  if (isWeekend && !rec) return { kind: 'weekend' };
  if (halfLeave) return { kind: 'half_leave_absent', ...halfLeave };
  if (c.kind === 'leave') return { kind: 'leave', label: c.label };
  if (c.kind === 'leave_pending') return { kind: 'leave_pending', label: c.label };
  return { kind: 'absent' };
}

const partText = (part) => (part ? `${part} half` : 'half day');
const otherPart = (part) => (part === '1st' ? '2nd half' : part === '2nd' ? '1st half' : 'other half');

// Text shown for the non-present kinds.
export function dayOutcomeText(o) {
  if (o.kind === 'holiday') return `Holiday — ${o.label || ''}`.trim();
  if (o.kind === 'leave') return `On Leave — ${o.label}`;
  if (o.kind === 'leave_pending') return `${o.label} — leave pending approval`;
  return 'Absent';
}

// Tag for a half-day leave, e.g. "Casual Leave — 1st half" (or "... — 1st half, pending approval").
export const halfLeaveText = (h) => `${h.label} — ${partText(h.part)}${h.pending ? ', pending approval' : ''}`;
// What the half that is NOT on leave counts as when the person did not check in.
export const absentOtherHalfText = (h) => `Absent — ${otherPart(h.part)}`;

// Days counted for the summary cards (a half day counts 0.5), so the cards always agree with the list.
export const absentCount = (o) => (o.kind === 'absent' ? 1 : o.kind === 'half_leave_absent' ? 0.5 : 0);
export const leaveCount = (o) => {
  if (o.kind === 'leave') return 1;
  const half = o.kind === 'half_leave_absent' ? o : (o.kind === 'present' ? o.halfLeave : null);
  return half && !half.pending ? 0.5 : 0;
};
